import type { Country } from '@tenders/shared';

/**
 * The deployment's country in English — what schema.org `areaServed` /
 * `spatialCoverage` names. The /plans JSON-LD said «Uzbekistan» on both
 * deployments, so kaztender.com told search engines its tariffs were for
 * Uzbekistan. Keyed by `Country`, so a new deployment does not compile until it
 * has a name here.
 */
const COUNTRY_NAME_EN: Record<Country, string> = {
  uz: 'Uzbekistan',
  kz: 'Kazakhstan',
  es: 'Spain',
  cl: 'Chile',
};

export function countryNameEn(code: Country): string {
  return COUNTRY_NAME_EN[code];
}

/**
 * The `spatialCoverage` Place of the company and price Datasets (buyer,
 * supplier and /prices/:ikpu pages). Spain names itself in the language of its
 * pages, «España» (audit 2026-10-21: «Spain» was an English leftover on a
 * Spanish-only site). Uzbekistan AND Kazakhstan keep the «Uzbekistan» those
 * pages have always shipped: on KZ it is the same slip /plans had, but changing
 * kaztender.com's output is KZ's call.
 */
export function datasetPlaceName(code: Country): string {
  // Chile is «Chile» in Spanish and in English alike.
  if (code === 'cl') return 'Chile';
  return code === 'es' ? 'España' : 'Uzbekistan';
}
